import React from "react";
import { useTranslation } from "react-i18next";

// Placeholder page: the Knowledge hub content has not been designed yet.
const KnowledgeHub: React.FC = () => {
  const { t } = useTranslation("sidebar");

  return (
    <div className="h-full">
      <div className="hidden lg:flex items-center bg-white border-b border-slate-200/80 px-6 py-4">
        <h1 className="text-xl font-bold text-gray-900 font-['Plus_Jakarta_Sans']">Knowledge hub</h1>
      </div>
      <section aria-label={t("knowledgeHub")} className="h-full" />
    </div>
  );
};

export default KnowledgeHub;
